import { number, string } from 'prop-types';
import React from 'react';
import { colors } from '@ajaibid/components';

const IconHistory = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.47764 8.55473C7.71559 6.43956 10.0633 5 12.7715 5C16.7905 5 20.0001 8.16038 20.0001 12C20.0001 15.8396 16.7905 19 12.7715 19C9.64775 19 7.00319 17.0846 5.98864 14.426C5.79173 13.91 5.21381 13.6514 4.69782 13.8483C4.18183 14.0452 3.92316 14.6231 4.12007 15.1391C5.43067 18.5735 8.81916 21 12.7715 21C17.8416 21 22.0001 16.9969 22.0001 12C22.0001 7.00307 17.8416 3 12.7715 3C9.31604 3 6.29121 4.85489 4.70957 7.61673L4.46147 6.74838C4.30881 6.21405 3.75462 5.89354 3.22367 6.0325C2.69272 6.17147 2.38606 6.71728 2.53872 7.25161L3.53872 10.7516C3.61908 11.0329 3.8171 11.2684 4.08118 11.3968C4.34527 11.5252 4.64928 11.5338 4.91403 11.4203L8.41403 9.92033C8.91698 9.70478 9.13937 9.118 8.91076 8.60971C8.68215 8.10142 8.08911 7.86411 7.58616 8.07965L6.47764 8.55473Z"
      fill={color}
    />
    <path
      d="M12.0001 8C12.5524 8 13.0001 8.44772 13.0001 9V12H16.0001C16.5524 12 17.0001 12.4477 17.0001 13C17.0001 13.5523 16.5524 14 16.0001 14H12.0001C11.4478 14 11.0001 13.5523 11.0001 13V9C11.0001 8.44772 11.4478 8 12.0001 8Z"
      fill={color}
    />
  </svg>
);

IconHistory.propTypes = {
  color: string,
  size: number,
};

IconHistory.defaultProps = {
  color: colors.AJAIB_BLUE_5,
  size: 24,
};

export default IconHistory;
